import React, {useState, useEffect, Fragment, memo } from 'react';
import { 
         Grid,
         LinearProgress,
         Paper,
         TextField,
        } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { 
    LoadingOutlined as LoadingOutlinedIcon,
    SaveOutlined as SaveOutlinedIcon,
   } from '@ant-design/icons';
import {     MonetizationOn as MonetizationOnIcon, } from '@material-ui/icons'
import { SnackbarProvider, useSnackbar } from 'notistack';
import { useAuth } from "../Auth";
import Swal from 'sweetalert2';
import { 
    Button as ButtonAntd,
    Checkbox as CheckboxAntd,
    Popconfirm,
    Switch as SwitchAntd, 
    Tooltip as TooltipAntd, 
} from 'antd';
const moment = require('moment-timezone');  


function ADICIONAL_ADD(){
    const { authTokens, setOpen, setRuta } = useAuth(); 
    const { enqueueSnackbar} = useSnackbar();
    const [ DatosD, setDatosD ] = useState({
        Zona:'',
        Nombres:'',
        CI:'',
        idCliente:'',
        Correo:'',
        Celular:'',
        idForMikrotik:'',
        idServicio:'',
        Status:'Pendiente',
        Tipo:'',
        Detalle:'',
        Observacion:'',
        isMensual:false,
        Valor:0,
        Registro:'',
        Modificacion:'',
        Eventos:[],
        Fecha:(()=>{
            const laZona="America/Guayaquil";
            const laFecha = moment().tz(laZona).format();
            return laFecha.split('T')[0];
            })(),
        Hora:'09:00',
        isOT:false,
        idOT:'',
        numOT:'',
        Tecnico:'',
        NombresTecnico:'',
        isFree:false,
        Direccion:'',
        isCorreo:false,
        numAdicional:0,
        isIva:false,
        EquipoTipo:'',
        EquipoMarca:'',
        EquipoModelo:'',
        EquipoMac:''
    })
    const [ arrClientes,  setArrClientes  ] = useState([]);
    const [ arrServicios, setArrServicios ] = useState([]);
    const [ isContinuoSave, setContinuoSave ] = useState(false);
    const [ isSavingAdicional, setSavingAdicional ] = useState(false);
    const [ isByNombres, setByNombres ] =  useState(true);
    const [ getTecnicos, setTecnicos ] = useState([]);
    const [ DataZona, setDataZona ] = useState([]);
    const [ getTipos, setTipos ] = useState([]);
    const [ getMarcas, setMarcas ] = useState([]);
    const [ getModelos, setModelos ] = useState([]);
    const [ getMacs, setMacs ] = useState([]);
    const [ arrTipos ] = useState([ "SERVICIO", "SOPORTE", "VENTA", "OTROS" ]);
    const [ getStock, setStock ] = useState([]);
    
    useEffect(()=>{
        (async ()=>{ 
            const PeticionZona = await fetch(`/api/zonas/byEmpresa/${authTokens.Empresa}`);
            const resultZona = await PeticionZona.json();
            if(authTokens.Type === 'ADMINISTRADOR'){
                setDataZona(resultZona.map(el=>el.Zona));
            }else{
                setDataZona(authTokens.Zonas.map(valZon=> valZon.Zona)); 
            }
            setOpen(false);
            setRuta('/Adicionales/Crear');
            const dataTecnicos = await fetch(`/api/users/tecnicos/byEmpresa/${authTokens.Empresa}`);
            const jsonTecnicos = await dataTecnicos.json();
            setTecnicos(jsonTecnicos);
            const getStock_ = await fetch(`/api/Stocks/byEmpresa/${authTokens.Empresa}`);
            const jsnStock_ = await getStock_.json();
            setStock(jsnStock_);
            const dataTipos = await fetch('/api/Tipos');
            const infoTipos =  await dataTipos.json();
            setTipos(infoTipos.map(el=> el.Tipo));
        })();       

    },[]); // eslint-disable-line react-hooks/exhaustive-deps


    useEffect(()=>{
        if(isContinuoSave){
            setContinuoSave(false);
            handleAdd();
        }
    },[isContinuoSave])// eslint-disable-line react-hooks/exhaustive-deps

    const handlePreAdd = ()=>{ 
        setSavingAdicional(true);
        if(DatosD.Valor === 0 ){
            enqueueSnackbar('INGRESE UN VALOR', {variant:'error'});
            setSavingAdicional(false);
        }else if(DatosD.Tipo === ''){
            enqueueSnackbar('SELECCIONE UN TIPO', {variant:'error'});
            setSavingAdicional(false);
        }else if(DatosD.Detalle === '' ){
            enqueueSnackbar('INGRESE UN DETALLE', {variant:'error'});
            setSavingAdicional(false);
        }else if(DatosD.isCorreo === true && DatosD.Correo === '' ){
            enqueueSnackbar('INGRESE UN CORREO ', {variant:'error'});
            setSavingAdicional(false);
        }else{
            handleAdd();
        }
        
    };

    const handleAdd = ()=>{ 
        const val_0 = parseInt(DatosD.Valor); // VALOR NUMERICO
        const val_1 = parseFloat( val_0 * 0.12);
        const val_2 = parseFloat(val_1).toFixed(2); // IVA
        const val_3 = parseFloat(val_0) + parseFloat(val_2); // SUMA VALOR + IVA
        const val_4 = parseFloat( val_3 ).toFixed(2);
        const val_5 = parseFloat( DatosD.Valor ).toFixed(2);
        const objeto = {...DatosD};
        objeto.Status = DatosD.isMensual ? 'Activo' : 'Pendiente';
        objeto.Iva = val_2;
        objeto.ValorIva = val_4;
        objeto.Valor = val_5;
        objeto.Empresa = authTokens.Empresa;
        fetch('/api/Adicionales',{
            method:'POST',
            body: JSON.stringify(objeto),
            headers:{
                'Content-Type': 'application/json'
            }
        }) 
        .then(response=> response.json())
        .then(result =>{
            if(result._id){
                if(DatosD.isOT){
                    const objeto = {...DatosD};
                    objeto.isAdicional  = true;
                    objeto.idAdicional  = result._id;
                    objeto.numAdicional = result.numAdicional;
                    objeto.Status = 'Pendiente';
                fetch('/api/Ots',{
                    method:'POST',
                    body: JSON.stringify(objeto),
                    headers:{
                        'Content-Type': 'application/json'
                    }
                }) 
                .then(response=> response.json())
                .then(result2 =>{
                    setSavingAdicional(false);
                    if(result2._id){
                        Swal.fire({
                            title:`SE HA CREADO EL ADICIONAL ${result.numAdicional} & OT N° ${result2.numOT}`,
                            icon:'success',
                            showDenyButton: false,
                            showCancelButton: false,
                            confirmButtonColor:'#005596',
                            width:600,
                            confirmButtonText:'OK',
                        }).then((result)=>{
                            if(result.isConfirmed){                                  
                                handleClearAll();
                            }
                        })
        
                    }else{
                        enqueueSnackbar(result.status, {variant:'error'});
                        
                    } 
                });
                }else{
                    Swal.fire({
                        title:`SE HA CREADO EL ADICIONAL N° ${result.numAdicional}`,
                        icon:'success',
                        showDenyButton: false,
                        showCancelButton: false,
                        confirmButtonColor:'#005596',
                        width:600,
                        confirmButtonText:'OK',
                    }).then((result)=>{
                        if(result.isConfirmed){
                            handleClearAll();
                        }
                    })
                }
            }else{
                enqueueSnackbar(result.status, {variant:'error'});
                
            } 
        });
    };

    const handleClearAll = ()=>{
        setDatosD({...DatosD,
            Zona:'',
            Nombres:'',
            CI:'',
            idCliente:'',
            Correo:'',
            Celular:'',
            idForMikrotik:'',
            idServicio:'',
            Status:'Pendiente',
            Tipo:'',
            Detalle:'',
            Observacion:'',
            isMensual:false,
            isOT:false,
            idOT:'',
            Valor:0,
            Registro:'',
            Modificacion:'',
            Eventos:[],
            Fecha:(()=>{
                const laZona="America/Guayaquil";
                const laFecha = moment().tz(laZona).format();
                return laFecha.split('T')[0];
                })(),
            Hora:'09:00',
            Tecnico:'',
            NombresTecnico:'',
            isFree:false,
            Direccion:'',
            isCorreo:false,
            numAdicional:0,
            isIva:false,
        });
        setArrClientes([]);
        setArrServicios([]);
        setByNombres(true);
        setSavingAdicional(false);
    };

    const handleSelectZone = (e, value, reason)=>{
        if(reason === 'select-option'){
            fetch('/api/clientes/byEmpresa&Zona',
                { 
                    method:'POST', 
                    body: JSON.stringify({Empresa:authTokens.Empresa, Zona:value}), 
                    headers:{'Content-Type': 'application/json'}
                }) 
            .then(response=> response.json())
            .then(result =>{
                if(result.Status){
                    enqueueSnackbar(result.Status, {variant:'error'})
                }else{
                    const resultClientes = result.filter(value=>value.Status === 'Activo');
                    const arrClientes = [];
                    for(const x in resultClientes){
                        const objeto = {...resultClientes[x]};
                        const arrFiltrado = resultClientes[x].Servicios.filter(el_=>el_.ZonaService === value);
                        if(arrFiltrado.length > 0){
                            objeto.Servicios = arrFiltrado;
                            arrClientes.push(objeto);
                        }
                    }     
                    setArrClientes(arrClientes);
                    setDatosD({...DatosD,
                        Zona:value,
                        Nombres:'',
                        CI:'',
                        Correo:'',
                        Celular:'',
                        idCliente:'',
                        idForMikrotik:'',
                        idServicio:'',
                        Direccion:'',
                    });
                }
            });
        }else{
            setDatosD({...DatosD,
                Zona:'',
                Nombres:'',
                CI:'',
                Correo:'',
                Celular:'',
                idCliente:'',
                idForMikrotik:'',
                idServicio:'',
                Direccion:'',
            });
            setArrClientes([]);
        }
    };

    const handleSelectClient = (e, value, reason)=>{
        if(reason === 'select-option'){
            if(isByNombres){
                const arrF = arrClientes.filter(el=>el.Nombres === value)[0];
                setArrServicios(arrF.Servicios);
                if(arrF.Servicios.length === 1){
                    setDatosD({...DatosD,
                        Nombres:value,
                        CI:arrF.CI,
                        idCliente:arrF._id,
                        Correo:arrF.Correo.map(el=>el.correo)[0],
                        Celular:arrF.Celular.map(el=>el.celular)[0],
                        idForMikrotik:arrF.Servicios[0].idForMikrotik,
                        idServicio:arrF.Servicios[0]._id,
                        Direccion:arrF.Servicios[0].Direccion,
                    });
                }else{
                    setDatosD({...DatosD,
                        Nombres:value,
                        CI:arrF.CI,
                        idCliente:arrF._id,
                        Correo:arrF.Correo.map(el=>el.correo)[0],
                        Celular:arrF.Celular.map(el=>el.celular)[0],
                        idForMikrotik:'',
                        idServicio:'',
                        Direccion:'',
                    });
                }
            }else{
                const arrF = arrClientes.filter(el=>el.CI === value)[0];
                setArrServicios(arrF.Servicios);
                if(arrF.Servicios.length === 1){
                    setDatosD({...DatosD,
                        Nombres:arrF.Nombres,
                        CI:value,
                        idCliente:arrF._id,
                        Correo:arrF.Correo.map(el=>el.correo)[0],
                        Celular:arrF.Celular.map(el=>el.celular)[0],
                        idForMikrotik:arrF.Servicios[0].idForMikrotik,
                        idServicio:arrF.Servicios[0]._id,
                        Direccion:arrF.Servicios[0].Direccion,
                    });
                }else{
                    setDatosD({...DatosD,
                        Nombres:arrF.Nombres,
                        CI:value,
                        idCliente:arrF._id,
                        Correo:arrF.Correo.map(el=>el.correo)[0],
                        Celular:arrF.Celular.map(el=>el.celular)[0],
                        idForMikrotik:'',
                        idServicio:'',
                        Direccion:'',
                    });
                }
            }
            
        }else{
            setDatosD({...DatosD,
                Nombres:'',
                CI:'',
                idCliente:'',
                Correo:'',
                Celular:'',
                idForMikrotik:'',
                idServicio:'',
                Direccion:'',
            })
            setArrServicios([]);
        }
    };

    const handleSelectServicio = (e, value, reason)=>{
        if(reason === 'select-option'){
            const arrF = arrServicios.filter(el=>el.idForMikrotik === value)[0];
            setDatosD({...DatosD,
                idForMikrotik:value,
                idServicio:arrF._id,
                Direccion:arrF.Direccion,
            });
        }else{
            setDatosD({...DatosD,
                idForMikrotik:'',
                idServicio:'',
                Direccion:'',
            });
        }
    };

    const handleSelectTipo = (e, value, reason)=>{
        if(reason === 'select-option'){               
            setDatosD({...DatosD,
                Tipo:value,
            });
        }else{
            setDatosD({...DatosD,
                Tipo:'',
            })
        }
    };

    const handleDatosD = ({target})=>{ setDatosD({...DatosD, [target.id]:target.value})};

    const handleMensual = (checked)=>{ setDatosD({...DatosD, isMensual:checked}) };

    const handleByNombres = (checked)=>{ setByNombres(checked); };

    const handleFree = ({target})=>{  setDatosD({...DatosD, isFree:target.checked}); };

    const handleCorreo = ({target})=>{  setDatosD({...DatosD, isCorreo:target.checked}); };

    const handleOT = ({target})=>{ setDatosD({...DatosD, isOT:target.checked}); };

    const handleIva = ({target})=>{ setDatosD({...DatosD, isIva:target.checked}); }; 

    const handleSelectTecnico = (e, value, reason)=>{
        if(reason === 'select-option'){
            const arrFil = getTecnicos.filter(el=> el.Nombres === value)[0];
            setDatosD({...DatosD, Tecnico:value, NombresTecnico:arrFil.NombresCompletos});
        }else{
            setDatosD({...DatosD, Tecnico:'', NombresTecnico:''});   
        }    
    };

    const handleSelectTipos = (e, value, reason)=>{
        if(reason === 'select-option'){
            setDatosD({...DatosD, EquipoTipo:value, EquipoMarca:'', EquipoModelo:'', EquipoMac:''});   
            setMarcas([...new Set(getStock.filter(el=>el.Tipo === value).map(el=> el.Marca))]);
            setModelos([]);
            setMacs([]);
        }else{
            setDatosD({...DatosD, EquipoTipo:'', EquipoMarca:'', EquipoModelo:'', EquipoMac:''});   
            setMarcas([]);
            setModelos([]);
            setMacs([]);
        }
    };

    const handleSelectMarcas = (e, value, reason)=>{
        if(reason === 'select-option'){
            setDatosD({...DatosD, EquipoMarca:value, EquipoModelo:'', EquipoMac:''});   
            setModelos([...new Set(getStock.filter(el=> el.Tipo === DatosD.EquipoTipo && el.Marca === value ).map(el=> el.Modelo))]);
            setMacs([]);
        }else{
            setDatosD({...DatosD, EquipoMarca:'', EquipoModelo:'', EquipoMac:''});   
            setModelos([]);
            setMacs([]);
        }
    };

    const handleSelectModelos = (e, value, reason)=>{
        if(reason === 'select-option'){
            setDatosD({...DatosD, EquipoModelo:value, EquipoMac:''});   
            setMacs(getStock.filter(el=> el.Tipo === DatosD.EquipoTipo && el.Marca === DatosD.EquipoMarca && el.Modelo === value && el.Status === 'Disponible'  ).map(el=>el.Mac));
        }else{
            setDatosD({...DatosD, EquipoModelo:'', EquipoMac:''});   
            setMacs([]);
        }
    };

    const handleSelectMac = (e, value, reason)=>{
        setDatosD({...DatosD, EquipoMac:value });   
    };


    return(

        <Grid container spacing={2} justifyContent='center' style={{padding:10, height:'90vh',overflowY:'auto', width:'100%', border:'1px solid #D0D3D4', borderRadius:5}}>
            <Grid item  lg={6} md={7} sm={10} xs={12}>
                <Paper elevation={3} style={{padding:5, width:'100%'}}>
                    <Grid container justifyContent='space-between' spacing={2}>
                        <Grid item xs={12} style={{height:5}}>
                            {isSavingAdicional &&  <LinearProgress color='secondary' /> }
                        </Grid>
                        <Grid item xs={12}>
                            <Paper elevation={1} >
                                <Grid container justifyContent='center' spacing={2} style={{alignItems:'center', padding:5}}> 
                                    <Grid item md={8} xs={12}>
                                        <Autocomplete
                                            id="Zona"
                                            options={DataZona}
                                            value={DatosD.Zona || ''}                              
                                            renderInput={(params) => <TextField {...params} label="Zona" variant="outlined" size='small' fullWidth color='primary'/>}
                                            onChange={handleSelectZone}  
                                            disabled={DatosD.isFree}
                                        />
                                    </Grid>   
                                    <Grid item md={4} xs={12}>
                                        <TextField 
                                            id='Valor'
                                            fullWidth
                                            label='Valor'
                                            value={DatosD.Valor || ''}
                                            onChange={handleDatosD}  
                                            variant='outlined'
                                            size='small'
                                            type='number'
                                            InputProps={{
                                                startAdornment: <MonetizationOnIcon color='primary'/>,
                                            }}
                                            //disabled={!isSelectedZona}
                                        />
                                    </Grid>                             
                                    <Grid item sm={2} xs={4}>
                                        <TooltipAntd title="CLIENTE EXTERNO" color='BLUE' >
                                            <CheckboxAntd onChange={handleFree} checked={DatosD.isFree}>
                                                FREE
                                            </CheckboxAntd>
                                        </TooltipAntd>
                                    </Grid>
                                    <Grid item sm={2} xs={4}>
                                        <TooltipAntd title="ENVIAR PROFORMA VIA CORREO" color='BLUE' >
                                            <CheckboxAntd onChange={handleCorreo} checked={DatosD.isCorreo}>
                                                CORREO
                                            </CheckboxAntd>
                                        </TooltipAntd>
                                    </Grid>
                                    <Grid item sm={2} xs={4}>
                                        <TooltipAntd title="DESEA CREAR UNA OT?" color='BLUE' >
                                            <CheckboxAntd onChange={handleOT} checked={DatosD.isOT}>
                                                OT
                                            </CheckboxAntd>
                                        </TooltipAntd>
                                    </Grid>
                                    <Grid item sm={2} xs={4}>
                                        <TooltipAntd title="INCLUIR IVA?" color='BLUE' >
                                            <CheckboxAntd onChange={handleIva} checked={DatosD.isIva}>
                                                IVA
                                            </CheckboxAntd>
                                        </TooltipAntd>
                                    </Grid>
                                    <Grid item sm={2} xs={4}>
                                        <TooltipAntd title="CI O NOMBRES" color='BLUE' >
                                            <SwitchAntd checkedChildren="ON" unCheckedChildren="OFF" checked={isByNombres} onChange={handleByNombres} />
                                        </TooltipAntd>  
                                    </Grid>
                                    
                                </Grid>
                            </Paper>
                        </Grid>
                        <Grid item xs={12}>
                            <Paper elevation={1} style={{padding:5}}>
                                <Grid container justifyContent='center' spacing={2}>

                                    {
                                        DatosD.isFree ?
                                        <Fragment>
                                            <Grid item md={7} xs={12}>
                                                <TextField 
                                                    id='Nombres'
                                                    fullWidth
                                                    label='Nombres'
                                                    value={DatosD.Nombres || ''}
                                                    onChange={handleDatosD}  
                                                    variant='outlined'
                                                    size='small'
                                                />
                                            </Grid>
                                            <Grid item md={5} xs={12}>
                                                <TextField 
                                                    id='CI'
                                                    fullWidth
                                                    label='CI'
                                                    value={DatosD.CI || ''}
                                                    onChange={handleDatosD}  
                                                    variant='outlined'
                                                    size='small'
                                                />
                                            </Grid>
                                        </Fragment>
                                        :
                                        <Fragment>
                                            <Grid item md={7} xs={12}>
                                                <Autocomplete
                                                    id="Cliente"
                                                    options={arrClientes.map(value=> isByNombres ? value.Nombres : value.CI)}
                                                    value={ isByNombres ? DatosD.Nombres : DatosD.CI || ''}                              
                                                    renderInput={(params) => <TextField {...params} label="Cliente" variant="outlined" size='small' fullWidth color='primary'/>}
                                                    onChange={handleSelectClient}  
                                                />
                                            </Grid>
                                            <Grid item md={5} xs={12}>
                                                <Autocomplete
                                                    id="Servicio"
                                                    options={arrServicios.map(value=>value.idForMikrotik)}
                                                    value={DatosD.idForMikrotik || ''}                              
                                                    renderInput={(params) => <TextField {...params} label="ID MIKROTIK" variant="outlined" size='small' fullWidth color='primary'/>}
                                                    onChange={handleSelectServicio}  
                                                    disabled={DatosD.isFree}
                                                />
                                            </Grid>
                                        </Fragment>
                                    }
                                    
                                    <Grid item md={6} xs={12}>
                                        <TextField 
                                            id='Celular'
                                            fullWidth
                                            label='Celular'
                                            value={DatosD.Celular || ''}
                                            onChange={handleDatosD}  
                                            variant='outlined'
                                            size='small'
                                            disabled={!DatosD.isFree}
                                        />
                                    </Grid>
                                    <Grid item md={6} xs={12}>
                                        <TextField 
                                            id='Correo'
                                            fullWidth
                                            label='Correo'
                                            value={DatosD.Correo || ''}
                                            onChange={handleDatosD}  
                                            variant='outlined'
                                            size='small'
                                            disabled={!DatosD.isFree}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField 
                                            id='Direccion'
                                            fullWidth
                                            label='Direccion'
                                            value={DatosD.Direccion || ''}
                                            onChange={handleDatosD}  
                                            variant='outlined'
                                            size='small'
                                            multiline
                                            disabled={!DatosD.isFree}
                                        />
                                    </Grid>
                                    {
                                        DatosD.isOT && 
                                        <Fragment>
                                            <Grid item xs={12}>
                                                <Autocomplete
                                                    id="Tecnico"
                                                    options={getTecnicos.map(el=>el.Nombres)}
                                                    value={DatosD.Tecnico || ''}                              
                                                    renderInput={(params) => <TextField {...params} label="Tecnico" variant="outlined" size='small' fullWidth color='primary'/>}
                                                    onChange={handleSelectTecnico}  
                                                />
                                            </Grid>
                                            <Grid item xl={8} lg={8} md={7} sm={12} xs={12} > 
                                                <TextField 
                                                    id='Fecha'
                                                    fullWidth
                                                    label='Fecha'
                                                    value={DatosD.Fecha || ''}
                                                    onChange={handleDatosD}
                                                    variant='outlined'
                                                    size='small'
                                                    margin='dense'
                                                    type='date'
                                                />                     
                                            </Grid>
                                            <Grid item xl={4} lg={4} md={5} sm={12} xs={12} > 
                                                <TextField 
                                                    id='Hora'
                                                    fullWidth
                                                    label='Hora'
                                                    value={DatosD.Hora || ''}
                                                    onChange={handleDatosD}
                                                    variant='outlined'
                                                    size='small'
                                                    margin='dense'
                                                    type='time'
                                                />                     
                                            </Grid>
                                        </Fragment>
                                    }

                                    <Grid item xs={9}>
                                        <Autocomplete
                                            id="Tipo"
                                            options={arrTipos}
                                            value={DatosD.Tipo || ''}                              
                                            renderInput={(params) => <TextField {...params} label="Tipo" variant="outlined" size='small' fullWidth color='primary'/>}
                                            onChange={handleSelectTipo}  
                                        />
                                    </Grid>
                                    <Grid item xs={3} style={{paddingTop:15}}>
                                        <TooltipAntd title="DESEA INCLUIRLO EN EL RECIBO MENSUAL" color='BLUE' >
                                            <SwitchAntd checkedChildren="SI" unCheckedChildren="NO" checked={DatosD.isMensual} onChange={handleMensual} />
                                        </TooltipAntd>  
                                    </Grid>
                                    {
                                        DatosD.Tipo === 'VENTA' &&
                                        <Grid item xs={12}>
                                            <Grid container justifyContent="center" spacing={1}>
                                                <Grid item md={6} xs={12}>
                                                    <Autocomplete
                                                        id="EquipoTipo"
                                                        options={getTipos}
                                                        value={DatosD.EquipoTipo || ''}                              
                                                        renderInput={(params) => <TextField {...params} label="Tipo" variant="outlined" size='small' fullWidth color='primary'/>}
                                                        onChange={handleSelectTipos}  
                                                    />
                                                </Grid> 
                                                <Grid item md={6} xs={12}>
                                                    <Autocomplete
                                                        id="EquipoMarca"
                                                        options={getMarcas}
                                                        value={DatosD.EquipoMarca || ''}                              
                                                        renderInput={(params) => <TextField {...params} label="Marca" variant="outlined" size='small' fullWidth color='primary'/>}
                                                        onChange={handleSelectMarcas}  
                                                    />
                                                </Grid> 
                                                <Grid item md={6} xs={12}>
                                                    <Autocomplete
                                                        id="EquipoModelo"
                                                        options={getModelos}
                                                        value={DatosD.EquipoModelo || ''}                              
                                                        renderInput={(params) => <TextField {...params} label="Modelo" variant="outlined" size='small' fullWidth color='primary'/>}
                                                        onChange={handleSelectModelos}  
                                                    />
                                                </Grid> 
                                                <Grid item md={6} xs={12}>
                                                    <Autocomplete
                                                        id='EquipoMac'                                            
                                                        options={getMacs}
                                                        value={DatosD.EquipoMac || ''}
                                                        onChange={handleSelectMac}
                                                        renderOption={(option) => (
                                                            <span style={{color: 'green'}}>{option}</span>
                                                        )}
                                                        renderInput={(params) => <TextField {...params} fullWidth label="Mac" variant="outlined" size='small'/>}
                                                    />
                                                </Grid> 
                                            </Grid>
                                        </Grid>
                                    }
                                    <Grid item xs={12}>
                                        <TextField 
                                            id='Detalle'
                                            fullWidth
                                            label='Detalle'
                                            value={DatosD.Detalle || ''}
                                            onChange={handleDatosD}  
                                            variant='outlined'
                                            size='small'
                                            multiline
                                            //disabled={!isSelectedZona}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField 
                                            id='Observacion'
                                            fullWidth
                                            label='Observacion'
                                            value={DatosD.Observacion || ''}
                                            onChange={handleDatosD}  
                                            variant='outlined'
                                            size='small'
                                            multiline
                                            //disabled={!isSelectedZona}
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <ButtonAntd block type="danger"  size='large'  onClick={handleClearAll}>
                                            RESETEAR
                                        </ButtonAntd>     
                                    </Grid>
                                    <Grid item xs={6}>            
                                        <Popconfirm
                                            title="DESEA CREAR ADICIONAL?"
                                            onConfirm={handlePreAdd}
                                            okText="SI"
                                            cancelText="NO"
                                        >
                                            <ButtonAntd block type="primary"  size='large' icon={isSavingAdicional ? <LoadingOutlinedIcon/> :<SaveOutlinedIcon/>} >
                                                GUARDAR
                                            </ButtonAntd>
                                        </Popconfirm>
                                    </Grid> 
                                </Grid>
                            </Paper>
                        </Grid>
                    </Grid>
                </Paper>
            </Grid>
            


            
            
        </Grid>  
    );
};

function ADD_ADICIONAL(){
    return (
        <SnackbarProvider maxSnack={3} hideIconVariant={false} dense >
          <ADICIONAL_ADD />
        </SnackbarProvider>
    );
};

export default memo(ADD_ADICIONAL);